(function () {
  'use strict';

  var ROOT_SEL = '[data-fd-ingredients-popup]';
  var TRIGGER_SEL = '[data-fd-see-ingredients]';
  var JSON_SEL = '[data-fd-ingredients-json]';
  var LOADER_MIN_MS = 220;

  var root = null;
  var panel = null;
  var titleEl = null;
  var imageWrap = null;
  var imageEl = null;
  var richtextEl = null;
  var compareEl = null;
  var priceEl = null;
  var atcBtn = null;
  var built = false;
  var currentProductId = null;
  var currentData = null;
  var loadToken = 0;
  var lastFocus = null;
  var pdpPriceObserver = null;
  var lastTrigger = null;

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function ensureRoot() {
    if (root) return root;
    root = qs(ROOT_SEL);
    if (!root) return null;
    panel = qs('[data-fd-ingredients-panel]', root);
    titleEl = qs('[data-fd-ingredients-title]', root);
    imageWrap = qs('[data-fd-ingredients-image-wrap]', root);
    imageEl = qs('[data-fd-ingredients-image]', root);
    richtextEl = qs('[data-fd-ingredients-richtext]', root);
    compareEl = qs('[data-fd-ingredients-compare]', root);
    priceEl = qs('[data-fd-ingredients-price]', root);
    atcBtn = qs('[data-fd-ingredients-atc]', root);
    return root;
  }

  function parseCardData(trigger) {
    var host =
      trigger.closest('[data-fd-ingredients-host]') ||
      trigger.closest('.alt-product-card-shell') ||
      trigger.closest('.alt-product-card') ||
      trigger.closest('[class*="pbfcm-product-card-"]') ||
      trigger.parentElement;
    var script = host ? host.querySelector(JSON_SEL) : null;
    if (!script && trigger.previousElementSibling && trigger.previousElementSibling.matches(JSON_SEL)) {
      script = trigger.previousElementSibling;
    }
    if (!script || !script.textContent) return null;
    try {
      var data = JSON.parse(script.textContent);
      if (host && host.getAttribute('data-fd-ingredients-source') && !data.source) {
        data.source = host.getAttribute('data-fd-ingredients-source');
      }
      if (data.source !== 'pdp') applyCardLivePrices(host || trigger, data);
      return data;
    } catch (e) {
      console.warn('[fd-ingredients] invalid JSON', e);
      return null;
    }
  }

  // Offer session and Intelligems reprice cards after render, so copy the card.
  function applyCardLivePrices(start, data) {
    var card = start.parentElement;
    while (card && card !== document.body) {
      if (card.querySelectorAll('[data-fd-ingredients-host]').length > 1) return;
      if (card.querySelector('[data-fd-offer-price]')) break;
      card = card.parentElement;
    }
    if (!card || card === document.body) return;
    var price = extractVisibleMoney(card.querySelector('[data-fd-offer-price]'));
    if (!price) return;
    data.price = trimMoneyZeros(price);
    if (data.comparePrice) {
      var compare = extractVisibleMoney(card.querySelector('.igPrice:not([data-fd-offer-price])'));
      if (compare) data.comparePrice = trimMoneyZeros(compare);
    }
  }

  function setLoading(on) {
    if (!root) return;
    root.classList.toggle('is-loading', !!on);
  }

  function trimMoneyZeros(value) {
    if (value == null || value === '') return value;
    // Only drop exact .00 — keep $58.80 / $54.40 as-is
    return String(value).replace(/\.00(?!\d)/, '');
  }

  function extractVisibleMoney(el) {
    if (!el) return null;
    var visible = el.querySelector('[aria-hidden="true"]');
    var text = ((visible || el).textContent || '').replace(/\s+/g, ' ').trim();
    return text || null;
  }

  function formatMoneyFromCents(cents) {
    if (!Number.isFinite(cents)) return null;
    var dollars = cents / 100;
    var fixed = dollars.toFixed(2);
    var withSymbol = '$' + fixed;
    return trimMoneyZeros(withSymbol);
  }

  function readPdpLivePrices() {
    var productFinal = extractVisibleMoney(document.getElementById('PBFCM-breakdown-product-final'));
    var productCompare = extractVisibleMoney(document.getElementById('PBFCM-breakdown-product-compare'));

    if (productFinal) {
      var cmp = productCompare && productCompare !== productFinal ? productCompare : null;
      return {
        price: trimMoneyZeros(productFinal),
        comparePrice: cmp ? trimMoneyZeros(cmp) : null,
      };
    }

    // Fallback: compute from buy-box state / hidden fields
    var qty = parseInt(document.getElementById('PBFCM-selected-quantity')?.value, 10) || 1;
    var selectedOpt = document.querySelector(
      '.PBFCM-PDP-frequency-selector__option--selected, [data-option-kind].PBFCM-PDP-frequency-selector__option--selected'
    );
    var blockQty = parseInt(selectedOpt?.dataset?.blockQty || selectedOpt?.getAttribute('data-block-qty'), 10);
    if (!Number.isFinite(blockQty) || blockQty < 1) blockQty = 1;
    var effectiveQty = qty * blockQty;

    var baseCents = parseInt(document.getElementById('PBFCM-base-price')?.value, 10);
    if (!Number.isFinite(baseCents)) return null;

    var isSub =
      document.getElementById('PBFCM-radio-monthly')?.checked ||
      selectedOpt?.dataset?.optionKind === 'subscription' ||
      (!!selectedOpt && selectedOpt.getAttribute('data-option-kind') === 'subscription');

    var unitSaleCents = baseCents;
    var unitCompareCents = baseCents;

    if (window.PBFCM_PDP && typeof window.PBFCM_PDP.getState === 'function') {
      var s = window.PBFCM_PDP.getState();
      if (s.frequency === 'monthly' || s.frequency === 'onetime') {
        isSub = s.frequency === 'monthly';
      }
      if (Number.isFinite(s.prices?.base) && s.prices.base > 0) {
        unitCompareCents = Math.round(s.prices.base * 100);
      }
      if (isSub && Number.isFinite(s.prices?.subscription) && s.prices.subscription > 0) {
        unitSaleCents = Math.round(s.prices.subscription * 100);
      } else if (!isSub && Number.isFinite(s.prices?.onetime) && s.prices.onetime > 0) {
        unitSaleCents = Math.round(s.prices.onetime * 100);
      }
    }

    if (isSub) {
      var alloc = parseInt(selectedOpt?.dataset?.allocationPrice || selectedOpt?.dataset?.unitPrice, 10);
      if (Number.isFinite(alloc) && alloc > 0) {
        unitCompareCents = alloc;
        var couponMult = 1;
        var subPct = parseFloat(document.getElementById('PBFCM-sub-discount-percentage')?.value);
        if (Number.isFinite(subPct) && subPct > 0 && subPct <= 100) {
          couponMult = (100 - subPct) / 100;
        }
        unitSaleCents = Math.round(alloc * couponMult);
      }
    }

    var saleTotal = unitSaleCents * effectiveQty;
    var compareTotal = unitCompareCents * effectiveQty;
    return {
      price: formatMoneyFromCents(saleTotal),
      comparePrice: compareTotal > saleTotal ? formatMoneyFromCents(compareTotal) : null,
    };
  }

  function applyAtcPrices(price, comparePrice) {
    if (!priceEl || !compareEl) return;
    if (comparePrice && comparePrice !== price) {
      compareEl.hidden = false;
      compareEl.textContent = trimMoneyZeros(comparePrice);
    } else {
      compareEl.hidden = true;
      compareEl.textContent = '';
    }
    priceEl.textContent = trimMoneyZeros(price) || '';
  }

  function syncPdpPricesIntoPopup() {
    if (!currentData || currentData.source !== 'pdp') return;
    var live = readPdpLivePrices();
    if (!live || !live.price) return;
    currentData.price = live.price;
    currentData.comparePrice = live.comparePrice;
    applyAtcPrices(live.price, live.comparePrice);
  }

  function stopPdpPriceWatch() {
    if (pdpPriceObserver) {
      pdpPriceObserver.disconnect();
      pdpPriceObserver = null;
    }
  }

  function startPdpPriceWatch() {
    stopPdpPriceWatch();
    document.removeEventListener('change', onPdpSelectionChange);
    document.removeEventListener('click', onPdpSelectionChange);
    if (!currentData || currentData.source !== 'pdp') return;

    var targets = [
      document.getElementById('PBFCM-breakdown-product-final'),
      document.getElementById('PBFCM-breakdown-product-compare'),
      document.getElementById('PBFCM-breakdown-subtotal-final'),
      document.getElementById('PBFCM-selected-quantity'),
      document.getElementById('PBFCM-selling-plan-id'),
    ].filter(Boolean);

    if (targets.length && typeof MutationObserver !== 'undefined') {
      pdpPriceObserver = new MutationObserver(function () {
        syncPdpPricesIntoPopup();
      });

      targets.forEach(function (el) {
        pdpPriceObserver.observe(el, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
        });
      });
    }

    document.addEventListener('change', onPdpSelectionChange);
    document.addEventListener('click', onPdpSelectionChange);
  }

  function onPdpSelectionChange(e) {
    if (!currentData || currentData.source !== 'pdp') return;
    if (!root || !root.classList.contains('is-open')) return;
    var t = e.target;
    if (!t) return;
    if (
      t.closest &&
      (t.closest('[data-quantity]') ||
        t.closest('.PBFCM-PDP-frequency-selector') ||
        t.closest('#PBFCM-subscription-interval-select') ||
        t.id === 'PBFCM-subscription-interval-select')
    ) {
      window.requestAnimationFrame(function () {
        window.setTimeout(syncPdpPricesIntoPopup, 50);
      });
    }
  }

  function applyContent(data) {
    if (!data) return;

    if (data.source === 'pdp') {
      var live = readPdpLivePrices();
      if (live && live.price) {
        data.price = live.price;
        data.comparePrice = live.comparePrice;
      }
    }

    titleEl.textContent = data.title || '';

    if (data.imageUrl) {
      imageWrap.hidden = false;
      imageEl.alt = data.imageAlt || data.title || '';
      if (imageEl.getAttribute('src') !== data.imageUrl) {
        imageEl.removeAttribute('src');
        imageEl.src = data.imageUrl;
      }
    } else {
      imageWrap.hidden = true;
      imageEl.removeAttribute('src');
      imageEl.alt = '';
    }

    richtextEl.innerHTML = data.ingredientsHtml || '<p>Ingredients information coming soon.</p>';

    applyAtcPrices(data.price, data.comparePrice);

    // Per card. The drawer is one shared element, so the card that opened it
    // decides whether its button carries a price, and the class has to be taken
    // off again for the next card that wants one.
    atcBtn.classList.toggle('fd-ingredients-popup__atc--no-price', !!data.hideAtcPrice);

    atcBtn.disabled = !data.available;
    atcBtn.setAttribute(
      'aria-label',
      data.available
        ? 'Add ' + (data.title || 'product') + ' to cart'
        : (data.title || 'Product') + ' - Currently unavailable'
    );

    currentData = data;
    currentProductId = data.productId;
    built = true;
  }

  function waitForImage(src) {
    if (!src) return Promise.resolve();
    return new Promise(function (resolve) {
      if (imageEl.complete && imageEl.getAttribute('src') === src && imageEl.naturalWidth) {
        resolve();
        return;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        imageEl.removeEventListener('load', finish);
        imageEl.removeEventListener('error', finish);
        resolve();
      }
      imageEl.addEventListener('load', finish);
      imageEl.addEventListener('error', finish);
      window.setTimeout(finish, 1200);
    });
  }

  function openWithData(data, opts) {
    if (!ensureRoot() || !data) return;
    opts = opts || {};

    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.classList.add('fd-ingredients-popup-open');

    var switching = built && currentProductId != null && currentProductId !== data.productId;
    var token = ++loadToken;

    if (!built || switching || opts.forceLoader) {
      setLoading(true);
      var started = Date.now();

      if (switching) {
        richtextEl.innerHTML = '';
        if (imageEl) imageEl.removeAttribute('src');
      }

      applyContent(data);
      startPdpPriceWatch();

      Promise.all([
        waitForImage(data.imageUrl),
        new Promise(function (r) {
          window.setTimeout(r, LOADER_MIN_MS);
        }),
      ]).then(function () {
        if (token !== loadToken) return;
        var elapsed = Date.now() - started;
        var remain = Math.max(0, LOADER_MIN_MS - elapsed);
        window.setTimeout(function () {
          if (token !== loadToken) return;
          syncPdpPricesIntoPopup();
          setLoading(false);
          if (panel) panel.focus({ preventScroll: true });
        }, remain);
      });
    } else {
      applyContent(data);
      startPdpPriceWatch();
      syncPdpPricesIntoPopup();
      setLoading(false);
    }
  }

  function close() {
    if (!ensureRoot()) return;
    stopPdpPriceWatch();
    document.removeEventListener('change', onPdpSelectionChange);
    document.removeEventListener('click', onPdpSelectionChange);
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fd-ingredients-popup-open');
    setLoading(false);

    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) {
        root.hidden = true;
      }
    }, 360);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  async function fallbackAddToCart(data, buttonElement) {
    if (typeof window.setButtonLoading === 'function') {
      window.setButtonLoading(buttonElement, true);
    } else {
      buttonElement.disabled = true;
    }

    try {
      var items = [];
      var starters = Array.isArray(data.starters)
        ? data.starters.filter(function (v) {
            return v && v !== 'blank';
          })
        : [];
      var sellingPlanId = data.sellingPlanId || '';
      var props = {
        _full_price: 'true',
        _product_type: 'rebrand',
      };
      if (sellingPlanId) {
        props._if_upgrade__selling_plan_id = String(sellingPlanId);
        props._is_subscription_purchase = 'true';
      }

      if (starters.length) {
        var bundleProps = {
          _bundle: 'starter-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8),
          _bundle_title: data.bundleName || data.title || 'Starter Pack',
          _bundle_name: data.bundleName || data.title || '',
          _page_path: window.location.pathname,
        };
        if (data.productId) bundleProps._parent_pdp = String(data.productId);
        if (data.handle) bundleProps._parent_pdp_handle = String(data.handle);

        starters.forEach(function (starterId) {
          var item = {
            id: parseInt(starterId, 10),
            quantity: 1,
            properties: Object.assign({}, props, bundleProps),
          };
          if (sellingPlanId) item.selling_plan = sellingPlanId;
          items.push(item);
        });
      } else {
        var single = {
          id: data.variantId,
          quantity: 1,
          properties: props,
        };
        if (sellingPlanId) single.selling_plan = sellingPlanId;
        items.push(single);
      }

      if (typeof window.addToCart === 'function') {
        await window.addToCart({ items: items });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        });
      }

      var cartResponse = await fetch('/cart.js');
      var updatedCart = await cartResponse.json();
      if (typeof updateCartDisplay === 'function') {
        updateCartDisplay(updatedCart);
        if (typeof updateCartCount === 'function') updateCartCount(updatedCart.item_count);
        if (typeof toggleCartOpen === 'function') toggleCartOpen();
      }
    } finally {
      if (typeof window.setButtonLoading === 'function') {
        window.setButtonLoading(buttonElement, false);
      } else {
        buttonElement.disabled = false;
      }
    }
  }

  function scrollToBuyBox() {
    var buyBox =
      document.getElementById('product-purchase-content') ||
      document.querySelector('.product-purchase-content') ||
      document.querySelector('[data-component="PBFCM-PDP-frequency-selector"]') ||
      document.querySelector('.PBFCM-PDP-frequency-selector');

    if (!buyBox) return false;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    buyBox.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });
    return true;
  }

  function scrollToCardAtc() {
    var card =
      (lastTrigger && lastTrigger.closest('.alt-product-card-shell')) ||
      (lastTrigger && lastTrigger.closest('.alt-product-card')) ||
      (lastTrigger && lastTrigger.closest('[class*="pbfcm-product-card-"]')) ||
      (lastTrigger && lastTrigger.closest('[data-fd-ingredients-host]')?.parentElement);

    if (!card && lastTrigger) {
      card = lastTrigger.closest('.alt-product-card__actions, [class*="pbfcm-card-actions-"]') || lastTrigger.parentElement;
    }
    if (!card) return false;

    var atc =
      card.querySelector('.alt-product-card__atc') ||
      card.querySelector('[class*="pbfcm-quick-add-"]') ||
      card.querySelector('button[id*="atc"]') ||
      card.querySelector('button[id*="quick-add"]') ||
      card.querySelector('button[type="button"]');

    var target = atc || card;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'center',
      inline: 'nearest',
    });
    return true;
  }

  function handleAtc(e) {
    e.preventDefault();
    if (!currentData) return;

    // PDP temporary: close + scroll to buy box (no add from popup)
    if (currentData.source === 'pdp') {
      close();
      window.setTimeout(function () {
        scrollToBuyBox();
      }, 120);
      return;
    }

    if (!currentData.available) return;
    addFromPopup(currentData);
  }

  async function addFromPopup(data) {
    var starters = Array.isArray(data.starters)
      ? data.starters.filter(function (v) {
          return v && v !== 'blank' && v !== 'null';
        })
      : null;
    if (starters && starters.length === 0) starters = null;

    try {
      if (typeof window.pbfcmAddToCart === 'function') {
        await window.pbfcmAddToCart(
          data.variantId,
          data.sellingPlanId || '',
          atcBtn,
          starters,
          data.bundleName || data.title || '',
          data.productId || '',
          data.handle || ''
        );
      } else {
        await fallbackAddToCart(data, atcBtn);
      }
      close();
    } catch (err) {
      // keep popup open so user can retry
    }
  }

  function onTriggerClick(e) {
    var trigger = e.target.closest(TRIGGER_SEL);
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var data = parseCardData(trigger);
    if (!data) return;
    lastTrigger = trigger;
    openWithData(data);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && root && root.classList.contains('is-open')) {
      e.preventDefault();
      close();
    }
  }

  function bind() {
    if (!ensureRoot()) return;

    document.addEventListener('click', onTriggerClick);
    document.addEventListener('keydown', onKeydown);

    var overlay = qs('[data-fd-ingredients-overlay]', root);
    var closeBtn = qs('[data-fd-ingredients-close]', root);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (atcBtn) atcBtn.addEventListener('click', handleAtc);

    if (panel && !panel.hasAttribute('tabindex')) {
      panel.setAttribute('tabindex', '-1');
    }
  }

  window.FDIngredientsPopup = {
    open: function (data) {
      openWithData(data, { forceLoader: true });
    },
    close: close,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
